import Icon from './images/icon-location-active.png';
import PdoIcon from './images/location-pdo.png';

export function getLocationIcon(isPdo = false) {
  return isPdo ? PdoIcon : Icon;
}
